/*
 * BD IMAGE IMPRINT V1.5.2 - exclude only marks/seals, not eduQua course photos
 * All substantive images displayed in the Bildungsdienst main content get
 * a clickable little * linking to https://www.bildungsdienst.ch/impressum/.
 * Decorative icons, brand marks and official certification seals are excluded.
 * This is a DOM overlay, never burned into a generated image.
 */
(function () {
  'use strict';
  if (window.BDImageImpressumV150) return;
  window.BDImageImpressumV150 = true;
  var root = document.querySelector('main#MainContent') ||
    document.querySelector('#MainContent') || document.querySelector('main');
  if (!root) return;
  var placed = new Map();
  var listening = new WeakSet();
  var reserved = /(?:logo|favicon|brand[-_]?mark|certification[-_]?seal|zertifizierungs[-_]?siegel|payment[-_]?icon|svg[-_]?icon|sprite|\/icons?\/|\/flags?\/)/i;
  var pending = false;
  var resizer = ('ResizeObserver' in window) ? new ResizeObserver(schedulePosition) : null;
  function excluded(image) {
    if (!image || !image.isConnected || image.closest('nav,[data-bd-imprint-exclude],.bd-imprint-image-star')) return true;
    var explicitCard = image.closest('[data-product-card]');
    if (explicitCard && explicitCard.querySelector('.bd-public-image-credit')) return true;
    if (image.getAttribute('aria-hidden') === 'true' || image.getAttribute('role') === 'presentation') return true;
    var s = (image.getAttribute('src') || '') + ' ' + (image.getAttribute('alt') || '');
    return reserved.test(s);
  }
  function activate(image) {
    if (placed.has(image) || excluded(image)) return;
    if (!listening.has(image)) {
      listening.add(image);
      image.addEventListener('load', function(){ activate(image); schedulePosition(); }, {passive:true});
    }
    var r = image.getBoundingClientRect();
    if ((image.naturalWidth && image.naturalWidth < 130) || (image.naturalHeight && image.naturalHeight < 80) || r.width < 28 || r.height < 22) return;
    var linked = image.closest('a[href]');
    var host = linked && root.contains(linked) ? linked.parentElement : image.parentElement;
    while (host && host !== root && window.getComputedStyle(host).display === 'inline') {
      host = host.parentElement;
    }
    if (!host || !root.contains(host)) return;
    if (window.getComputedStyle(host).position === 'static') host.classList.add('bd-imprint-image-host');
    var star = document.createElement('a');
    star.href = 'https://www.bildungsdienst.ch/impressum/';
    star.target = '_blank';
    star.rel = 'noopener noreferrer';
    star.className = 'bd-imprint-image-star';
    star.textContent = '*';
    star.title = 'Bildinformationen im Impressum';
    star.setAttribute('aria-label', 'Bildhinweis – Informationen im Impressum');
    star.setAttribute('data-bd-imprint-star', 'true');
    host.appendChild(star);
    placed.set(image, {host:host,star:star});
    if (resizer) { resizer.observe(image); resizer.observe(host); }
    position(image);
  }
  function position(image) {
    var item = placed.get(image); if(!item) return;
    if (!image.isConnected || !item.host.isConnected) { item.star.remove(); placed.delete(image); return; }
    var r = image.getBoundingClientRect();
    var h = item.host.getBoundingClientRect();
    if (r.width < 28 || r.height < 22) { item.star.style.display='none'; return; }
    item.star.style.display = 'flex';
    item.star.style.left = Math.max(0, Math.round(r.right-h.left-27))+'px';
    item.star.style.top = Math.max(0, Math.round(r.bottom-h.top-27))+'px';
  }
  function reposition() { pending = false; placed.forEach(function(_v,im){position(im);}); }
  function schedulePosition() { if (pending) return; pending = true; requestAnimationFrame(reposition); }
  function scan(from) {
    var items = from && from.matches && from.matches('img') ? [from] : [];
    if (from && from.querySelectorAll) from.querySelectorAll('img').forEach(function(im){items.push(im);});
    items.forEach(activate);
    schedulePosition();
  }
  scan(root);
  var mo = new MutationObserver(function(records) {
    records.forEach(function(rec) {
      rec.addedNodes.forEach(function(n){
        if (n.nodeType === 1 && n !== root) scan(n);
      });
    });
  });
  mo.observe(root,{childList:true,subtree:true});
  window.addEventListener('resize',function(){scan(root);}, {passive:true});
  window.addEventListener('pageshow',function(){scan(root);}, {passive:true});
  window.addEventListener('load',function(){scan(root);}, {once:true});
  window.setTimeout(function(){scan(root);}, 700);
  window.setTimeout(function(){scan(root);}, 1700);
})();

/* BD1.5: cover substantial CSS background imagery as well as <img> elements */
(function(){
 if(window.BDImageBackgroundImprint150)return;window.BDImageBackgroundImprint150=true;
 var root=document.querySelector('main#MainContent')||document.querySelector('#MainContent')||document.querySelector('main');
 if(!root)return;
 var imgClassSelector='[style*="background-image"],[class*="hero-media"],[class*="hero-photo"],[class*="hero-image"],[class*="image-background"],[class*="cover-photo"],[data-background-image]';
 function attach(node){
  if(!node||!node.isConnected||node.closest('nav,[data-bd-imprint-exclude]'))return;
  if(node.querySelector(':scope > .bd-imprint-image-star'))return;
  var css=getComputedStyle(node),bg=css.backgroundImage||'',rect=node.getBoundingClientRect();
  if(!/url\(/i.test(bg)||rect.width<110||rect.height<75)return;
  if(node.querySelector('img'))return;
  if(css.position==='static')node.classList.add('bd-imprint-image-host');
  var a=document.createElement('a');a.className='bd-imprint-image-star';a.href='https://www.bildungsdienst.ch/impressum/';
  a.target='_blank';a.rel='noopener noreferrer';a.title='Bildinformationen im Impressum';
  a.setAttribute('aria-label','Bildhinweis: Bildinformationen im Impressum öffnen');a.textContent='*';
  a.style.right='1px';a.style.bottom='1px';node.appendChild(a);
 }
 function scan(base){
  if(base.matches&&base.matches(imgClassSelector))attach(base);
  if(base.querySelectorAll)base.querySelectorAll(imgClassSelector).forEach(attach);
 }
 scan(root);
 new MutationObserver(function(records){records.forEach(function(r){r.addedNodes.forEach(function(n){if(n.nodeType===1&&n.tagName!=='A')scan(n)})})}).observe(root,{childList:true,subtree:true});
 window.addEventListener('resize',function(){scan(root)},{passive:true});
})();
